import { render, staticRenderFns } from "./scriptRouting.vue?vue&type=template&id=041fecd1&scoped=true"
import script from "./scriptRouting.vue?vue&type=script&lang=js"
export * from "./scriptRouting.vue?vue&type=script&lang=js"
import style0 from "./scriptRouting.vue?vue&type=style&index=0&id=041fecd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fecd1",
  null
  
)

export default component.exports